<template>
    <div class="betBuilderTicket notranslate">
        <div class="betBuilderTicket-title">
            <SvgIcon iconName="sportIcon_soccer" />
            <span
                v-if="mainScoreDisplay"
                class="live-score"
                data-testid="bet-builder-slip-main-score"
            >{{ mainScoreDisplay }}</span>
            <span class="teamName">{{ betSlip.match.homeTeamName }} - {{ betSlip.match.awayTeamName }}</span>
        </div>

        <div
            v-for="subBet in tickets"
            v-bind:key="subBet.selection.id"
            class="betBuilderTicket-list"
            v-bind:data-testid="`bet-builder-slip-leg-${subBet.selection.id}`"
        >
            <div class="betBuilderInfo">
                <div class="marketType">
                    <span
                        v-if="subBet.scoreDisplay"
                        class="live-score"
                        data-testid="bet-builder-slip-leg-score"
                    >{{ subBet.scoreDisplay }}</span>
                    {{ subBet.marketDisplayName }}
                </div>
                <div class="oddsGroup">
                    <span class="oddsType"> {{ subBet.optionName }}</span>
                    <span v-if="subBet.point" class="oddsPoint">{{ subBet.point }}</span>
                </div>
            </div>
            <div class="btn_close BetBuilderSlip_Btn_DeleteTicket" v-on:click="removeTicketOrBetSlip(subBet.selection.id)">
                <SvgIcon iconName="systemIcon_close2" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed, defineComponent } from 'vue';
    import { useBetBuilderSlipScore } from '@/libraries/composables/useBetBuilderSlipScore';
    import { useBetBuilderBetSlipStore } from '@/stores/betSlip/betBuilderBetSlipStore';
    import SvgIcon from '@/svg/SvgIcon.vue';

    export default defineComponent({
        name: 'BetBuilderTicket',
        components: {
            SvgIcon,
        },
        setup() {
            const { betSlip } = storeToRefs(useBetBuilderBetSlipStore());
            const { removeTicketOrBetSlip, convertBetBuilderTicket } = useBetBuilderBetSlipStore();

            const { mainScoreDisplay, getTicketScoreDisplay } = useBetBuilderSlipScore();
            const tickets = computed(() => betSlip.value.tickets.map(ticket => ({
                ...convertBetBuilderTicket(ticket),
                scoreDisplay: getTicketScoreDisplay(ticket),
            })));

            return {
                tickets,
                mainScoreDisplay,
                betSlip,
                removeTicketOrBetSlip,
            };
        },
    });
</script>

<style scoped lang="scss">
@import "@/scss/components/betbuilderticket";
</style>
